import {
  DATE_FORMATS,
  formatDate,
} from "../services/utils/date-and-time.utils";
import { store } from "../store";

export const API = {
  COMMON: {
    GET_INDUSTRIES: "/industries",
    GET_TITLES: "/titles",
    GET_TIMEZONES: "/timezone",
    GET_CATEGORIES: "/categories",
    GET_OPPORTUNITY_CATEGORIES: "/opportunity/categories",
    GET_NO_OF_EMP: "/no-of-employees",
    GET_TOPICS: "/topics",
    GET_APP_SETTINGS_CURRENT: "/app-settings/slot-rules",
    GET_COUNTRIES_LIST: "https://countriesnow.space/api/v0.1/countries",
    GET_STATES: "https://countriesnow.space/api/v0.1/countries/states",
  },
  AUTH: {
    LOGIN: "/auth/login",
    SIGNUP: "/auth/sign-up",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: (token) => `/auth/reset-password/${token}`,
    CHANGE_PASSWORD: (id) => `/user/update-password/${id}`,
    LOGOUT: "",
    VALIDATE_TOKEN: "",
    REFRESH_TOKEN: "/auth/refreshToken",
    UPDATE_USER_DETAILS: (id) => `/user/${id}`,
    GET_USER_DETAILS: (id) => `/user/${id}`,
    VALIDATE_TOKEN_AND_SIGNIN: (token) => `/auth/login-user/${token}`,
  },
  DASHBOARD: {
    GET_COMPLETED_PROJECT_COUNT: () =>
      `/dashboard/done-meeting-count?date=${formatDate(
        new Date(),
        DATE_FORMATS.yyymmdd
      )}`,
    GET_MEETING_COUNT: (params?: { status?: string; date?: string }) => {
      const search = new URLSearchParams();
      if (params?.status) search.set("status", params.status);
      if (params?.date) {
        search.set(
          "date",
          params.date ?? formatDate(new Date(), DATE_FORMATS.yyymmdd)
        );
      }
      const query = search.toString();
      return `/dashboard/meeting-count${query ? `?${query}` : ""}`;
    },
    GET_AMBASSADOR_REVENUE: `/dashboard/ambassador-revenue`,
    GET_CLIENT_REMAINING_MEETING_COUNT: `/dashboard/client-meetings`,
  },
  MY_SCHEDULE: {
    GET_CALENDAER_EVENTS: ({ startDate, endDate }) =>
      `/projects/invitations?from=${startDate}&to=${endDate}`,
  },
  MY_PROFILE: {
    GET_PROFILE_DETAILS: `/profile`,
    GET_PROFILE_DETAILS_BY_ID: (id) => `/profile/${id}`,
    UPDATE_PROFILE_DETAILS: `/profile`,
    UPDATE_PRODUCT_LIST: ({ id }) => `/technologies/${id}`,
    DELETE_PRODUCT: ({ id }) => `/technologies/${id}`,
    ADD_PRODUCT_LIST: `/technology`,
    UPLOAD_VENDOR_COVER: `/profile/upload/cover`,
    UPLOAD_VENDOR_LOGO: `/profile/upload/logo`,
    CLEAR_NOTIFICATIONS: "/profile/clear-notifications",
    FINISH_PROFILE_SETUP: "/profile/finish-profile",
    CREATE_DEFAULT_MARKETPLACE_PROFILE: `/client/convert-marketplace`,
    TRANSFER_MANAGEMENT_RIGHTS: "/user/migrate",
  },
  INVITATIONS: {
    GET_INVITATIONS: ({ selectedPage, selectedPageSize, status = "" }) =>
      `/projects/invitations?page=${selectedPage}&limit=${selectedPageSize}&status=${status}`,
    GET_INVITATION_BY_ID: (id) => `/project/invitation/${id}`,
    GET_INVITATION_BY_ID_NO_AUTH: (id, token) =>
      `/project/preview-invitation/${id}?token=${token}`,
    GET_MEETINGS: `/ambassador-invitations`,
    UPDATE_INVITATION: ({ id }) => `/project/invitation/update/${id}`,
    SUBMIT_AMBASSADOR_RESPONSE: (id) => `/project/invitation/response/${id}`,
    SUBMIT_AMBASSADOR_SELECTED_SLOT: (id) =>
      `/project/invitation/select-time-slot/${id}`,
    SUBMIT_VENDOR_SELECTED_SLOT: (id) =>
      `/project/invitation/select-time-slot/${id}`,
    SUBMIT_VENDOR_APPROVE: (id) => `/project/invitation/approved/${id}`,
    SEND_VENDOR_CALENDLY_SLOT: (id) =>
      `/project/invitation/send-calendly/${id}`,
    SUBMIT_MARK_AS_COMPLETED: (id) => `/project/invitation/done/${id}`,
    SUBMIT_MARK_AS_CANCELLED: (id) =>
      `/project/invitation/reject-schedule/${id}`,
    SUBMIT_INVITATION_REJECTED: (id) => `/project/invitation/reject/${id}`,
    REJECT_BY_TOKEN: (token) =>
      `/project/invitation/reject-by-token?token=${token}`,
    POST_TRANSFER_ROLE: `/delegate`,
    GET_MEETING_SUMMARY: (token) =>
      `/ambassador-invitation/meeting/summary/${token}`,
    GET_AMBASSADOR_INVITATION_RECORDINGS: ({
      from,
      to,
      clientId,
      ambassadorId,
    }) =>
      `/ambassador-invitations/recordings?withDetails=true&from=${from}&to=${to}&clientId=${clientId}&ambassadorId=${ambassadorId}&limit=100`,
    GET_AMBASSADOR_INVITATION_PARTICIPANTS: `/ambassador-invitations/participants`,
    SUBMIT_AMBASSADOR_SUGGESTED_SLOT: (id) =>
      `/project/invitation/add-suggested-time-slot/${id}`,
    REQUEST_COORDINATION: (id) =>
      `/project//invitation/unavailable-on-suggested-time/${id}`,
    SUBMIT_RESCHEDULE: (id) => `/project/invitation/reschedule/${id}`,
    RESCHEDULE_REQUEST: (id) => `/project/invitation/reschedule-request/${id}`,
    CONFIRM_ATTENDANCE: (id) => `/project/invitation/confirm-attendance/${id}`,
  },
  AMBASSADORS: {
    GET_AMBASSADORS: ({ selectedPage, selectedPageSize, searchValue }) =>
      `/ambassadors?page=${selectedPage}&limit=${selectedPageSize}&search=${searchValue}`,
    GET_AMBASSADOR_DETAILS: (id) => `/ambassador/${id}`,
  },
  PROJECT: {
    CREATE_PROJECT: "/project",
    SUBMIT_VENDOR_AVAILIBILITY: (id) =>
      `/project/invitation/add-time-slot/${id}`,
    GET_PROJECTS: ({ selectedDate, selectedStatus }) =>
      `/projects?limit=1000&date=${selectedDate || ""}&${selectedStatus ? `&status=${selectedStatus}` : ""
      }`,
    GET_AMBASSADOR_LIST_FOR_PROJECT: "/project/ambassadors",
    SUBMIT_BATCH_AMBASSADOR_REQUEST: "/profile/more-ambassador-request",
    GET_RECORDING: (token) =>
      `/ambassador-invitation/meeting/recording/${token}`,
    GET_BLOCKED_DATES: ({ from, to }) =>
      `/projects/blocked-dates?from=${from}&to=${to}`,
    GET_UPCOMING_MEETINGS: (timezone = "") =>
      `/project/upcoming-meetings?timezone=${encodeURIComponent(timezone)}`,
  },
  CALENDLY: {
    GET_CALENDLY_URL: `/calendly/auth/url`,
    REVOKE_CALENDLY_URL: `/calendly/revoke`,
    CHECK_AUTH_CODE: (code) => `/calendly/check/auth/${code}`,
    GET_EVENT_TYPES: `/calendly/event-types`,
    SET_DEFAULT_EVENT_TYPE: `/calendly/default-event-type`,
    GET_AVAILIBILITY: ({ id, start, end, timezone }) =>
      `/calendly/get-availability/${id}?start=${start}&end=${end}&timezone=${timezone}`,
  },
  OPPORTUNITY: {
    LIST: ({ selectedPage, selectedPageSize }) =>
      `/opportunities/insights?page=${selectedPage}&limit=${selectedPageSize}`,
    SUBMIT_FORM: (id) => `/opportunity/${id}`,
    UPDATE_FORM: (id) => `/opportunity/${id}`,
    SUBMIT_VENDOR_PROFILE_INTERESTED_IN: ({ id, isClient }) =>
      `/opportunity/interested-in/${id}?isClient=${isClient}`,
    SUBMIT_OPPORTUNITY_VENDOR_CONTACT_US: `/opportunity/contact-us`,
    GET_EMAIL_INSIGHT_BY_ID: (id) => `/opportunity/${id}`,
    LOG_VENDOR_PROFILE_VIEW_CLICK: ({ id, isClient }) =>
      `/opportunity/view-by/${id}?isClient=${isClient}`,
    UPLOAD_OPPORTUNITY_VENDOR_LOGO: (id) => `/opportunity/upload/logo/${id}`,
    UPLOAD_OPPORTUNITY_VENDOR_COVER: (id) => `/opportunity/upload/cover/${id}`,
    GET_PROFILE_BY_ID: `/opportunity`,
  },
  MARKETPLACE: {
    GET_MARKETPLACE_CATEGORIES_LIST: `/marketplace/categories`,
    GET_MARKETPLACE_STAGES_LIST: `/marketplace/stages`,
    POST_SUBMIT_CONTACT_REQUEST: `/marketplace/contact-us`,
    SEARCH_KEYWORDS_LIST: (searchValue) =>
      `/marketplace/keywords?search=${searchValue}`,
    GET_MARKETPLACE_VENDOR_DATA_BY_ID: (id, token = "") => {
      const isLoggedIn = Boolean(store.getState()?.auth?.user?.isLoggedIn);
      if (isLoggedIn) {
        return `/marketplace/marketplace-profile/${id}`;
      }
      return `/marketplace/profile/${id}${token ? `?token=${token}` : ""}`;
    },
    UPLOAD_MARKETPLACE_FILE: (field, id, token) =>
      `/marketplace/upload/file/${field}/${id}${token ? `?token=${token}` : ""
      }`,
  },
  HOLIDAYS: {
    LIST: ({ year }: { year: number }) =>
      `/holidays?year=${year}&active=true&limit=500`,
  },
  INITIATIVES: {
    SUGGEST_OBJECTIVE: "/ambassador-projects/generate-description",
    CREATE: "/ambassador-projects",
    LIST: "/ambassador-projects",
    UPDATE: (id: string) => `/ambassador-project/${id}`,
    DELETE: (id: string) => `/ambassador-project/${id}`,
  },
  TYPEFORM: {
    GET_TYPEFORM_QUESTIONS_FOR_VENDOR_FEEDBACK: `/typeform/form?type=ambassador`,
    SUBMIT_TYPEFORM_QUESTIONS_FOR_VENDOR_FEEDBACK: `/typeform/add-answer?type=ambassador`,
    GET_TYPEFORM_QUESTIONS_FOR_VENDOR_FEEDBACK_STATUS: ({
      ambassadorInvitationId,
      userID,
    }) => `/typeform/answer/${ambassadorInvitationId}/${userID}`,
    GET_REVIEW_REPORT_DETAILS: `/typeform/report/generate/all`,
    GET_REVIEW_REPORT_DETAILS_BY_CLIENT: (reportId) =>
      `/typeform/report/${reportId}`,
  },
};
